import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/domofon/styled';

export const Wrapper = styled.div`
    display: block;
`;

export const Title = styled.p`
    ${FONTS.H0};
    color: ${COLORS.white};
    margin: 8px 0;
    white-space: break-spaces;

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.H1};
    }

    @media (max-width: ${breakePoints.tablet}) {
        ${FONTS.H2};
    }

`;

export const PreTitleText = styled.h1`
    ${FONTS.H5};
    color: ${COLORS.white};
`;
